/**
 * 実効プレイ時間（時間）を求める。
 * 手動入力の play_time(時間) を優先し、無ければ Steam累計 steam_playtime_min(分) を時間換算（切り捨て）。
 * どちらも無ければ null。
 *
 * バックエンドのソート（Coalesce(play_time*60, steam_playtime_min)）と同じ「手動優先」ルール。
 */
export const effectivePlayTimeHours = (
  playTime: number | null | undefined,
  steamPlaytimeMin: number | null | undefined,
): number | null => {
  if (playTime != null) return playTime;
  if (steamPlaytimeMin != null) return Math.floor(steamPlaytimeMin / 60);
  return null;
};
